import React, { useEffect, useRef, useState } from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { Backspace } from '@material-ui/icons'
import { ChevronLeft, ChevronRight, Search, X } from 'react-feather'
import { isEmpty } from 'lodash'

import CourseCard from '../CourseCard'
import useStyles from './styles'

const SCROLL_AMOUNT = 480

const CoursesRow = ({
  courses,
  hasAnyEnrolled,
  companyName,
  portalToken,
  searchTerm,
  onClearSearch,
  title,
}) => {
  const classes = useStyles()
  const rowRef = useRef(null)
  const [canScroll, setCanScroll] = useState(false)

  useEffect(() => {
    const checkScroll = () => {
      if (rowRef.current) {
        setCanScroll(rowRef.current.scrollWidth > rowRef.current.clientWidth)
      }
    }
    checkScroll()
    window.addEventListener('resize', checkScroll)
    return () => window.removeEventListener('resize', checkScroll)
  }, [courses])

  const scrollLeft = () => {
    if (rowRef.current) rowRef.current.scrollLeft -= SCROLL_AMOUNT
  }

  const scrollRight = () => {
    if (rowRef.current) rowRef.current.scrollLeft += SCROLL_AMOUNT
  }

  if (!hasAnyEnrolled) {
    return (
      <Box className={classes.emptyBox}>
        <Typography color="primary" className={classes.emptyTitle}>
          Bem-vindo!
        </Typography>
        <Typography className={classes.emptySubtitle}>
          {companyName ? (
            <>
              Você ainda não possui treinamentos inscritos em{' '}
              <strong>{companyName}</strong>. Entre em contato com o responsável
              para solicitar acesso.
            </>
          ) : (
            'Você ainda não possui treinamentos inscritos. Entre em contato com o responsável para solicitar acesso.'
          )}
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      {isEmpty(courses) ? (
        <Box className={classes.noResultsBox}>
          {searchTerm && (
            <Typography className={classes.noResultsQuery}>
              Nenhum resultado para <strong>&ldquo;{searchTerm}&rdquo;</strong>
            </Typography>
          )}
          <Box className={classes.noResultsIconWrapper}>
            <X size={32} className={classes.noResultsX} />
            <Search size={72} />
          </Box>
          <Typography className={classes.noResultsTitle}>
            Nenhum curso encontrado
          </Typography>
          <Typography className={classes.noResultsSubtitle}>
            Ops! Não encontramos nenhum curso com esse nome.
            <br />
            Tente usar palavras-chave mais genéricas ou limpe os filtros.
          </Typography>
          <Box className={classes.noResultsActions}>
            <Button
              variant="contained"
              className={classes.clearSearchButton}
              startIcon={<Backspace fontSize="small" />}
              onClick={onClearSearch}
            >
              Limpar busca
            </Button>
          </Box>
        </Box>
      ) : (
        <>
          <Typography className={classes.header}>
            {title || 'Bem-vindo!'}
          </Typography>
          <Box mb={2}>
            <Typography variant="body1">
              {title
                ? 'Seus cursos em andamento aparecerão aqui. Que tal começar por um destes?"'
                : 'Aproveite a plataforma e explore todos os cursos disponíveis para você. Estude no seu ritmo, adquira novos conhecimentos e garanta o seu certificado de conclusão!'}
            </Typography>
          </Box>
          <Box className={classes.scrollWrapper}>
            {canScroll && (
              <Box
                className={classes.navButton}
                style={{ left: -18 }}
                onClick={scrollLeft}
              >
                <ChevronLeft size={18} />
              </Box>
            )}
            <Box ref={rowRef} className={classes.row}>
              {courses.map((course) => (
                <CourseCard
                  key={course.id}
                  course={course}
                  portalToken={portalToken}
                />
              ))}
            </Box>
            {canScroll && (
              <Box
                className={classes.navButton}
                style={{ right: -18 }}
                onClick={scrollRight}
              >
                <ChevronRight size={18} />
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  )
}

export default CoursesRow
